// removed by extract-text-webpack-plugin
module.exports = {"auditTemplateBlockDetailsBlock":"AuditTemplateBlockDetailsBlock__auditTemplateBlockDetailsBlock__2QdN4","info":"AuditTemplateBlockDetailsBlock__info__3vf-m","icon":"AuditTemplateBlockDetailsBlock__icon__67Hk0","infoValue":"AuditTemplateBlockDetailsBlock__infoValue__2m7yA","bottomInfo":"AuditTemplateBlockDetailsBlock__bottomInfo__2LD2G","role":"AuditTemplateBlockDetailsBlock__role__mVX3u","roleIcon":"AuditTemplateBlockDetailsBlock__roleIcon__1u4qD"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockView/AuditTemplateBlockCard/AuditTemplateBlockDetailsBlock/AuditTemplateBlockDetailsBlock.scss
// module id = 1638
// module chunks = 0